import { render, staticRenderFns } from "./create-educational-material.vue?vue&type=template&id=219df39b&scoped=true&"
import script from "./create-educational-material.vue?vue&type=script&lang=js&"
export * from "./create-educational-material.vue?vue&type=script&lang=js&"
import style0 from "./create-educational-material.vue?vue&type=style&index=0&id=219df39b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219df39b",
  null
  
)

export default component.exports